import type { ICheckboxOption } from '@/creditflowresearch/ui/common/hooks/sidebar/useCheckboxFilter';

const mapToCheckboxOptions = <T extends { id: string | number }>(
  boundaryIds: (string | number)[] | undefined,
  dictionary: T[],
  getLabel: (item: T) => string = (item) => (item as T & { name: string }).name,
): ICheckboxOption<T['id']>[] => (boundaryIds ?? [])
  .map((id) => dictionary.find((d) => d.id === id))
  .filter(Boolean)
  .map((item) => ({ value: item.id, name: getLabel(item) }));

export default mapToCheckboxOptions;
